import React, { useState } from "react";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import "./calendar.scss";
import { isMobile } from "react-device-detect";
import { useHistory, useParams } from "react-router-dom";
import useCalendlyTracking from "./useCalendlyTracking";

const CalendarWide = (props) => {
  const { utm, handleEvent } = useCalendlyTracking(props);

  const history = useHistory();
  const [showButtons, setShowButtons] = useState(false);
  const showCalendarButtons = () => {
    setShowButtons(true);
  };

  useCalendlyEventListener({
    onProfilePageViewed: () => console.log(""),
    onDateAndTimeSelected: () => console.log(""),
    onEventTypeViewed: () => console.log(""),
    onEventScheduled: (e) => handleEvent(),
  });

  // const getUrl = () => {

  //     if (props['company-page']) {
  //         return 'https://calendly.com/talekroni/30min?hide_event_type_details=1&hide_gdpr_banner=1';
  //     } else if (props.companyId) {
  //         return 'https://calendly.com/d/ykb-5gr-r88/better?hide_gdpr_banner=1';
  //     } else
  //         return 'https://calendly.com/d/d4g-h5b-b33/meet-with-me?hide_event_type_details=1&hide_gdpr_banner=1&month=2023-04';
  // }

  const getUrl = () => {
    if (props["company-page"]) {
      return "https://calendly.com/ofra-erez/15min?hide_event_type_details=1&hide_gdpr_banner=1&month=2026-05";
    } else if (props.companyId) {
      return "https://calendly.com/d/ykb-5gr-r88/better?hide_event_type_details=1&hide_gdpr_banner=1&month=2026-05";
    }

    return "https://calendly.com/d/d56-qkn-h6z/better?hide_event_type_details=1&hide_gdpr_banner=1&month=2026-05";
  };

  const getStyles = () => {
    let styles = {};
    if (isMobile) styles = { height: "80vh", width: "100%" };
    else styles = { height: "1000px", width: "610px" };
    if (props.styles) styles = { ...styles, ...props.styles };
    return styles;
  };

  return (
    <>
      <div className="no-good-time">
        לא מצאתם מועד שמתאים לכם?{" "}
        {!showButtons && (
          <span className="click" onClick={showCalendarButtons}>
            לחצו כאן
          </span>
        )}
      </div>
      {showButtons && (
        <div className="calendar-buttons">
          <button onClick={() => history.push("/noConvenientTime")}>
            אין מועד שמתאים לי
          </button>

          <button onClick={() => history.push("/meetingToday")}>
            רוצה להיפגש היום
          </button>

          <button onClick={() => history.push("/moreInfo")}>
            רוצה לקבל מידע נוסף
          </button>
        </div>
      )}

      <section>
        <div className="calendar-wide-container" id="zoom-schedule">
          <InlineWidget
            styles={getStyles()}
            url={getUrl()}
            pageSettings={{
              backgroundColor: "ffffff",
              hideEventTypeDetails: false,
              hideLandingPageDetails: false,
              primaryColor: "00a2ff",
              textColor: "4d5055",
            }}
            utm={utm}
          />
        </div>
      </section>
    </>
  );
};

export default CalendarWide;
